import { render } from "./ObjectEditForm.vue?vue&type=template&id=e0316806"
import script from "./ObjectEditForm.vue?vue&type=script&lang=js"
export * from "./ObjectEditForm.vue?vue&type=script&lang=js"

import "./ObjectEditForm.vue?vue&type=style&index=0&id=e0316806&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__